import { apiClient } from '@/shared/api';

import { ArticleTagsResponse } from '../config';

export async function getArticleTagsApi() {
  const response = await apiClient<ArticleTagsResponse>('article-tags');
  return response.tags;
}
